import { useEffect, useState } from "react";
import AudioPlayer from "./components/AudioPlayer";
import { HlsAudioPlayer } from "./utils/HlsAudioPlayer";

const HlsTest: React.FC = () => {
  const [hlsAudioPlayer] = useState<HlsAudioPlayer>(new HlsAudioPlayer());
  const [streamUrl, setStreamUrl] = useState<string>(
    "http://localhost:5000/audio/oaktown.david@gmail.com/live-playlist.m3u8"
  );

  const handlePlay = () => {
    hlsAudioPlayer.play(streamUrl).catch((error) => {
      console.error("Playback failed:", error);
    });
  };

  useEffect(() => {
    return () => {
      hlsAudioPlayer.destroy();
      console.log("HlsAudioPlayer destroyed");
    };
  }, [hlsAudioPlayer]);

  return (
    <div>
      <div className="mb-4">
        <input
          type="text"
          value={streamUrl}
          onChange={(e) => setStreamUrl(e.target.value)}
          placeholder="Enter HLS stream URL"
          className="border p-2 w-[640px]"
        />
        <button
          onClick={handlePlay}
          className="bg-blue-500 text-white p-2 ml-2"
        >
          Play
        </button>
      </div>
      <div className="hidden md:block w-64">
        <AudioPlayer hlsAudioPlayer={hlsAudioPlayer} />
      </div>
    </div>
  );
};

export default HlsTest;